import loadable from '@loadable/component';


export const PreviewImage = loadable(
  () => import('./PreviewImage'),
  {}
);
